package com.essntl.uikit.components.scroll

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
internal actual fun EsHorizontalScrollbarPlatform(
    scrollState: ScrollState,
    modifier: Modifier,
    reverseLayout: Boolean,
    interactionSource: MutableInteractionSource
) {}

@Composable
internal actual fun EsHorizontalScrollbarPlatform(
    lazyListState: LazyListState,
    modifier: Modifier,
    reverseLayout: Boolean,
    interactionSource: MutableInteractionSource
) {}

@Composable
internal actual fun EsHorizontalScrollbarPlatform(
    lazyGridState: LazyGridState,
    modifier: Modifier,
    reverseLayout: Boolean,
    interactionSource: MutableInteractionSource
) {}
